/**
 * @fileoverview Agent definition for world-species-ideation-v3.
 *
 * This agent generates ideas for species (creatures, races, flora)
 * that could appear in the story world.
 *
 * @category world-building.species.creation
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-species-ideation-v3',
  kind: 'primitive',
  name: 'World Species Ideation',
  description: 'Generates ideas for species (creatures, races, flora) in your story world.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.species.creation',
    usedBy: ['use-world-species-ideation-v3.ts'],
    usedInComposites: [],
    relatedAgents: [
      'world-species-details-ideation-v3',
      'world-species-details-generator-v3',
    ],
  },
};
